export const POP_UP_WIDGET_VIEW = {
    home: "home",
    waysToEarnPoints: "waysToEarnPoints",
    newsletterSubscription: "newsletterSubscription",
    birthday: "birthday",
    siteShare: "siteShare",
    waysToSpendPoints: "waysToSpendPoints",
    customerRewards: "customerRewards",
    freeProduct: "freeProduct",
    variableDiscount: "variableDiscount",
    vipTiers: "vipTiers",
    faq: "faq",
    history: "history",
    qrCode: "qrCode",
} as const;
